<template>
    <div>
        <div :id="'Div' + nomeFormulario" :name="'Div' + nomeFormulario">
            <form :method="metodoFormulario" :action="linkAction" :id="nomeFormulario" :name="nomeFormulario" @submit.prevent="insereOuAtualiza()" novalidate>
                <div v-if="!edit">
                    <slot name="csrf">

                    </slot>
                </div>
                <input type="hidden" name="id_empresa" :value="cliente.id">

                <template v-if="cliente.CadastroTipo!=0 && cliente.CadastroTipo==2">
                    <!-- Resumo dos erros de validação (os campos podem estar em outra aba) -->
                    <div class="alert alert-danger" role="alert" v-if="possuiErroConfiguracao || possuiErroDadosUnidade">
                        <strong><b-icon icon="exclamation-triangle"></b-icon> Não foi possível salvar. Revise os campos:</strong>
                        <ul class="mb-0 mt-1">
                            <li v-for="erro in resumoErros" :key="erro.campo">
                                <a href="#" class="alert-link" @click.prevent="irParaCampo(erro.campo)">{{ erro.titulo }}</a>: {{ erro.mensagens.join(' ') }}
                            </li>
                        </ul>
                    </div>

                    <ul class="nav nav-tabs cfg-abas" id="configTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="mascaras-tab" data-toggle="tab" href="#mascaras" role="tab" aria-controls="mascaras" aria-selected="true">
                                <b-icon icon="input-cursor-text"></b-icon> Máscaras de ofertas
                                <span v-if="errors.mascarainscricao || errors.mascarapse" class="cfg-alerta" title="Há campos com erro nesta aba"></span>
                                <span v-else-if="mascarasPendentes" class="cfg-alerta cfg-alerta--aviso" title="Há máscaras obrigatórias não preenchidas"></span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tipocontato-tab" data-toggle="tab" href="#tipocontato" role="tab" aria-controls="tipocontato" aria-selected="false">
                                <b-icon icon="telephone"></b-icon> Tipos de contato
                                <span v-if="errors.codigotipocontatotelefone || errors.codigotipocontatoemail" class="cfg-alerta" title="Há campos com erro nesta aba"></span>
                                <span v-else-if="!cliente.codigotipocontatotelefone || !cliente.codigotipocontatoemail" class="cfg-alerta cfg-alerta--aviso" title="Tipos de contato não selecionados"></span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tipodocumento-tab" data-toggle="tab" href="#tipodocumento" role="tab" aria-controls="tipodocumento" aria-selected="false">
                                <b-icon icon="file-earmark-check"></b-icon> Documentos obrigatórios
                                <span class="badge badge-pill cfg-contagem">{{ docs_configurados_unidade.length }}</span>
                                <span v-if="errors.custom_field_id || errors.document_id" class="cfg-alerta" title="Há campos com erro nesta aba"></span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="dadosunidade-tab" data-toggle="tab" href="#dadosunidade" role="tab" aria-controls="dadosunidade" aria-selected="false">
                                <b-icon icon="building"></b-icon> Dados da unidade
                                <span v-if="possuiErroDadosUnidade" class="cfg-alerta" title="Há campos com erro nesta aba"></span>
                            </a>
                        </li>
                    </ul>

                    <div class="tab-content pt-3" id="configTabContent">
                        <!-- Máscaras -->
                        <div class="tab-pane fade show active" id="mascaras" role="tabpanel" aria-labelledby="mascaras-tab">
                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="input-cursor-text"></b-icon> Máscaras</legend>
                                <p class="ec-form-secao__descricao">
                                    Definem como o nome das ofertas é montado ao integrar turmas com o CRM. Combine as macros separando-as por <code>-</code>.
                                    <b>As alterações valem já para as próximas integrações.</b>
                                </p>

                                <div class="form-row">
                                    <div v-for="m in mascaras" :key="m.campo" class="form-group col-lg-6">
                                        <label :for="m.id" :class="{ 'ec-obrigatorio': m.obrigatoria }">
                                            {{ m.titulo }}
                                            <small v-if="m.obrigatoria" class="text-muted font-weight-normal">(módulo {{ m.modulo }} ativo)</small>
                                        </label>
                                        <div class="input-group">
                                            <input type="text" spellcheck="false" autocomplete="off" class="form-control cfg-mascara__input" :class="{ 'is-invalid': errors[m.erro] || m.analise.invalidas.length, 'cfg-mascara__input--alvo': mascaraAlvo==m.campo }" :id="m.id" :name="m.id" :placeholder="m.placeholder" v-model="cliente[m.campo]" @focus="mascaraAlvo=m.campo" @blur="normalizarMascara(m.campo)">
                                            <div class="input-group-append" v-if="cliente[m.campo]">
                                                <button type="button" class="btn btn-outline-secondary" @click="cliente[m.campo]=''; mascaraAlvo=m.campo" title="Limpar máscara"><b-icon icon="x"></b-icon></button>
                                            </div>
                                        </div>
                                        <div class="invalid-feedback d-block" v-if="errors[m.erro]">{{ errors[m.erro][0] }}</div>
                                        <div class="invalid-feedback d-block" v-else-if="m.analise.invalidas.length">
                                            Macro{{ m.analise.invalidas.length>1 ? 's' : '' }} desconhecida{{ m.analise.invalidas.length>1 ? 's' : '' }}: {{ m.analise.invalidas.join(', ') }}. Ela{{ m.analise.invalidas.length>1 ? 's' : '' }} será{{ m.analise.invalidas.length>1 ? 'ão' : '' }} ignorada{{ m.analise.invalidas.length>1 ? 's' : '' }} no nome da oferta.
                                        </div>

                                        <!-- macros da máscara como etiquetas removíveis -->
                                        <div class="cfg-tokens" v-if="m.analise.tokens.length">
                                            <span v-for="(token, i) in m.analise.tokens" :key="i" class="cfg-token" :class="{ 'cfg-token--invalida': !macrosPorNome[token] }" :title="macrosPorNome[token] ? macrosPorNome[token].descricao : 'Macro desconhecida'">
                                                {{ token || '(vazio)' }}
                                                <button type="button" class="cfg-token__remover" @click="removerMacro(m.campo, i)" :aria-label="'Remover ' + token">&times;</button>
                                            </span>
                                        </div>

                                        <div class="cfg-previa">
                                            <span class="cfg-previa__rotulo"><b-icon icon="eye"></b-icon> Exemplo do nome da oferta</span>
                                            <span v-if="m.analise.previa" class="cfg-previa__texto">{{ m.analise.previa }}</span>
                                            <span v-else class="cfg-previa__texto text-muted font-italic">Adicione macros para ver o resultado</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="cfg-macros">
                                    <div class="cfg-macros__cabecalho">
                                        <span><b>Macros disponíveis</b> — clique para adicionar à <b>{{ mascaraAlvo=='mascaraofertapse' ? 'máscara PSE' : 'máscara de inscrição' }}</b></span>
                                        <div class="btn-group btn-group-sm" role="group" aria-label="Máscara de destino">
                                            <button type="button" class="btn" :class="mascaraAlvo=='mascaraofertainscricao' ? 'btn-primary' : 'btn-outline-primary'" @click="mascaraAlvo='mascaraofertainscricao'">Inscrição</button>
                                            <button type="button" class="btn" :class="mascaraAlvo=='mascaraofertapse' ? 'btn-primary' : 'btn-outline-primary'" @click="mascaraAlvo='mascaraofertapse'">PSE</button>
                                        </div>
                                    </div>
                                    <div class="cfg-macros__lista">
                                        <button v-for="macro in macros" :key="macro.nome" type="button" class="cfg-macro" :class="{ 'cfg-macro--usada': macroUsada(macro.nome) }" @click="adicionarMacro(macro.nome)" :title="macro.descricao + ' — ex.: ' + macro.exemplo">
                                            <b-icon :icon="macroUsada(macro.nome) ? 'check' : 'plus'"></b-icon> {{ macro.nome }}
                                            <small>{{ macro.descricao }}</small>
                                        </button>
                                    </div>
                                </div>

                                <details class="cfg-ajuda">
                                    <summary><b-icon icon="question-circle"></b-icon> Regras e exemplos prontos</summary>
                                    <ul class="mb-2">
                                        <li>Separe as macros somente com <code>-</code>, sem espaços (os espaços são removidos automaticamente).</li>
                                        <li>Use letras maiúsculas (convertidas automaticamente ao sair do campo).</li>
                                        <li>Com <code>ANOINICIO</code> e <code>SEMESTREINICIO</code> juntos, o período sai {{ cliente.escrevesemestreextenso==1 ? 'por extenso (ex.: 2026 - 1º Semestre)' : 'abreviado (ex.: 2026/1)' }}.</li>
                                    </ul>
                                    <div class="cfg-exemplos">
                                        <div v-for="exemplo in exemplos" :key="exemplo" class="cfg-exemplo">
                                            <div class="cfg-exemplo__textos">
                                                <code>{{ exemplo }}</code>
                                                <small class="text-muted">{{ montarPrevia(exemplo) }}</small>
                                            </div>
                                            <button type="button" class="btn btn-outline-primary btn-sm text-nowrap" @click="usarExemplo(exemplo)">
                                                Usar na {{ mascaraAlvo=='mascaraofertapse' ? 'PSE' : 'inscrição' }}
                                            </button>
                                        </div>
                                    </div>
                                </details>
                            </fieldset>
                        </div>

                        <!-- Tipos de contato -->
                        <div class="tab-pane fade" id="tipocontato" role="tabpanel" aria-labelledby="tipocontato-tab">
                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="telephone"></b-icon> Tipos de contato</legend>
                                <p class="ec-form-secao__descricao">Tipos de contato do ERP usados para gravar o telefone e o e-mail dos alunos inscritos.</p>
                                <div class="form-row">
                                    <div class="form-group col-lg-6">
                                        <label for="inputCodigoTipoContatoTelefone" class="ec-obrigatorio">Tipo de contato para telefone</label>
                                        <select class="custom-select" :class="{ 'is-invalid': errors.codigotipocontatotelefone }" id="inputCodigoTipoContatoTelefone" name="inputCodigoTipoContatoTelefone" v-model="cliente.codigotipocontatotelefone" :disabled="tipoContatoTelefone.length==0">
                                            <option :value="0">{{ tipoContatoTelefone.length ? 'Selecione o tipo de contato' : 'Nenhum tipo retornado pelo ERP' }}</option>
                                            <option v-for="tipocontato,key in tipoContatoTelefone" :key="key" :value="tipocontato.CODIGOTIPOCONTATOITEM">{{ tipocontato.DESCRICAO }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.codigotipocontatotelefone">{{ errors.codigotipocontatotelefone[0] }}</div>
                                    </div>
                                    <div class="form-group col-lg-6">
                                        <label for="inputCodigoTipoContatoEmail" class="ec-obrigatorio">Tipo de contato para e-mail</label>
                                        <select class="custom-select" :class="{ 'is-invalid': errors.codigotipocontatoemail }" id="inputCodigoTipoContatoEmail" name="inputCodigoTipoContatoEmail" v-model="cliente.codigotipocontatoemail" :disabled="tipoContatoEmail.length==0">
                                            <option :value="0">{{ tipoContatoEmail.length ? 'Selecione o tipo de contato' : 'Nenhum tipo retornado pelo ERP' }}</option>
                                            <option v-for="tipocontato,key in tipoContatoEmail" :key="key" :value="tipocontato.CODIGOTIPOCONTATOITEM">{{ tipocontato.DESCRICAO }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.codigotipocontatoemail">{{ errors.codigotipocontatoemail[0] }}</div>
                                    </div>
                                </div>
                                <p v-if="tipoContatoTelefone.length==0 || tipoContatoEmail.length==0" class="form-text mt-0">
                                    <b-icon icon="info-circle"></b-icon> Se a lista vier vazia, confira a integração da unidade com o ERP (código da unidade e credenciais da empresa).
                                </p>
                            </fieldset>
                        </div>

                        <!-- Documentos obrigatórios -->
                        <div class="tab-pane fade" id="tipodocumento" role="tabpanel" aria-labelledby="tipodocumento-tab">
                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="file-earmark-check"></b-icon> Documentos obrigatórios do aluno</legend>
                                <div class="cfg-docs-cabecalho">
                                    <p class="ec-form-secao__descricao mb-0">Relacione cada campo personalizado do CRM ao documento equivalente no ERP.</p>
                                    <button type="button" class="btn btn-outline-primary btn-sm" :disabled="sincronizando" @click.prevent="sincronizarTodos();" title="Atualiza as listas de documentos (ERP) e de campos personalizados (CRM)">
                                        <span v-if="sincronizando" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                        <b-icon v-else icon="arrow-repeat"></b-icon> {{ sincronizando ? 'Sincronizando...' : 'Sincronizar listas' }}
                                    </button>
                                </div>

                                <!-- formulário de/para: campo do CRM → documento do ERP -->
                                <div class="cfg-depara-form" :class="{ 'cfg-depara-form--editando': editandoDocumento }">
                                    <div v-if="editandoDocumento" class="cfg-depara-form__titulo"><b-icon icon="pencil"></b-icon> Alterando relação</div>
                                    <div class="cfg-depara-grade">
                                        <div class="cfg-depara-grade__lado">
                                            <label for="camposPersonalizado" class="ec-obrigatorio"><span class="cfg-origem cfg-origem--crm">De · CRM</span> Campo personalizado</label>
                                            <select v-if="campos_lista.length>0" class="custom-select" :class="{ 'is-invalid': errors.custom_field_id }" name="camposPersonalizado" id="camposPersonalizado" v-model="docs_custom_fields.custom_field_id">
                                                <option :value="0">Selecione um campo personalizado</option>
                                                <option v-for="campo in campos_lista" :key="campo.id" :value="campo.id">{{ campo.nome }}{{ campoJaRelacionado(campo.id) ? ' — já relacionado' : '' }}</option>
                                            </select>
                                            <div v-else class="form-control-plaintext text-muted">Lista vazia. Clique em <b>Sincronizar listas</b>.</div>
                                            <div class="invalid-feedback d-block" v-if="errors.custom_field_id">{{ errors.custom_field_id[0] }}</div>
                                        </div>
                                        <div class="cfg-depara-grade__seta" aria-hidden="true"><b-icon icon="arrow-right"></b-icon></div>
                                        <div class="cfg-depara-grade__lado">
                                            <label for="docsAluno" class="ec-obrigatorio"><span class="cfg-origem cfg-origem--erp">Para · ERP</span> Documento do aluno</label>
                                            <select v-if="docs_lista.length>0" class="custom-select" :class="{ 'is-invalid': errors.document_id }" name="docsAluno" id="docsAluno" v-model="docs_custom_fields.document_id">
                                                <option :value="0">Selecione um documento</option>
                                                <option v-for="doc in docs_lista" :key="doc.id" :value="doc.id">{{ doc.descricao }}</option>
                                            </select>
                                            <div v-else class="form-control-plaintext text-muted">Lista vazia. Clique em <b>Sincronizar listas</b>.</div>
                                            <div class="invalid-feedback d-block" v-if="errors.document_id">{{ errors.document_id[0] }}</div>
                                        </div>
                                        <div class="cfg-depara-grade__acoes">
                                            <button type="button" class="btn btn-primary" :disabled="salvandoDocumento || !docs_custom_fields.custom_field_id || !docs_custom_fields.document_id" @click.prevent="inserirAlterarDocumentCustomField()">
                                                <span v-if="salvandoDocumento" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <b-icon v-else :icon="editandoDocumento ? 'check2' : 'plus'"></b-icon> {{ editandoDocumento ? 'Salvar' : 'Relacionar' }}
                                            </button>
                                            <button v-if="editandoDocumento" type="button" class="btn btn-outline-secondary" @click.prevent="cancelarDocumentCustomField()">Cancelar</button>
                                        </div>
                                    </div>
                                </div>

                                <!-- campos do CRM que ainda não têm documento: atalho para relacionar -->
                                <div v-if="camposSemRelacao.length && docs_configurados_unidade.length" class="cfg-pendentes">
                                    <span class="cfg-pendentes__rotulo"><b-icon icon="exclamation-circle"></b-icon> {{ camposSemRelacao.length }} campo{{ camposSemRelacao.length>1 ? 's' : '' }} do CRM sem documento:</span>
                                    <button v-for="campo in camposPendentesVisiveis" :key="campo.id" type="button" class="cfg-pendente" :disabled="editandoDocumento" @click="relacionarCampo(campo)" :title="'Relacionar ' + campo.nome">
                                        <b-icon icon="plus"></b-icon> {{ campo.nome }}
                                    </button>
                                    <button v-if="camposSemRelacao.length>8" type="button" class="btn btn-link btn-sm p-0" @click="mostrarTodosPendentes=!mostrarTodosPendentes">
                                        {{ mostrarTodosPendentes ? 'mostrar menos' : 'e mais ' + (camposSemRelacao.length-8) }}
                                    </button>
                                </div>

                                <div class="table-responsive mb-3">
                                    <table v-ec-datatable class="table table-sm table-hover ec-tabela mb-0 cfg-depara">
                                        <thead class="ec-thead">
                                            <tr>
                                                <th class="text-left"><span class="cfg-origem cfg-origem--crm">De · CRM</span> Campo personalizado</th>
                                                <th class="ec-dt-sem-ordem cfg-depara__seta"><span class="sr-only">Relacionado a</span></th>
                                                <th class="text-left"><span class="cfg-origem cfg-origem--erp">Para · ERP</span> Documento do aluno</th>
                                                <th class="text-right ec-tabela__col-acoes"><span class="sr-only">Ações</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="docs_configurados_unidade.length==0">
                                                <td colspan="4" class="ec-tabela__estado">
                                                    <div class="cfg-depara__vazio" aria-hidden="true">
                                                        <span class="cfg-origem cfg-origem--crm">CRM</span>
                                                        <b-icon icon="arrow-right"></b-icon>
                                                        <span class="cfg-origem cfg-origem--erp">ERP</span>
                                                    </div>
                                                    <p>Nenhuma relação configurada. Escolha um campo do CRM e o documento do ERP acima e clique em <b>Relacionar</b>.</p>
                                                </td>
                                            </tr>
                                            <tr v-for="docs_unidade, key in docs_configurados_unidade" :key="key" :class="{ 'cfg-depara__linha--editando': docs_custom_fields.id==docs_unidade.id }">
                                                <td class="text-left" data-label="Campo do CRM">
                                                    <span class="cfg-depara__nome">{{ docs_unidade.custom_field.nome }}</span>
                                                    <code class="cfg-depara__codigo" title="Coluna do campo no CRM">{{ docs_unidade.custom_field.coluna }}</code>
                                                </td>
                                                <td class="text-center cfg-depara__seta" aria-hidden="true"><b-icon icon="arrow-right"></b-icon></td>
                                                <td class="text-left" data-label="Documento do ERP">
                                                    <span class="cfg-depara__nome">{{ docs_unidade.document.descricao }}</span>
                                                </td>
                                                <td class="ec-tabela__col-acoes" data-label="Ações">
                                                    <div class="ec-acoes">
                                                        <span v-if="docs_custom_fields.id==docs_unidade.id" class="ec-status ec-status--info">Em edição</span>
                                                        <template v-else>
                                                            <button type="button" :disabled="editandoDocumento || salvandoDocumento" class="btn btn-sm ec-acao" @click.prevent="alterarConfigDoc(docs_unidade)" v-b-tooltip.hover title="Alterar relação" aria-label="Alterar relação"><b-icon icon="pencil-fill"></b-icon></button>
                                                            <button type="button" :disabled="editandoDocumento || salvandoDocumento" class="btn btn-sm ec-acao ec-acao--perigo" @click.prevent="excluirDocumentCustomField(docs_unidade)" v-b-tooltip.hover title="Remover relação" aria-label="Remover relação"><b-icon icon="trash-fill"></b-icon></button>
                                                        </template>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>
                        </div>

                        <!-- Dados da unidade -->
                        <div class="tab-pane fade" id="dadosunidade" role="tabpanel" aria-labelledby="dadosunidade-tab">
                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="building"></b-icon> Identificação</legend>
                                <div class="form-row">
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="tipoCadastroPessoa" class="ec-obrigatorio">Tipo de cadastro</label>
                                        <select :disabled="edit || visualizar" id="tipoCadastroPessoa" name="tipoCadastroPessoa" class="custom-select" v-model="tipoCadastro">
                                            <option value="2">CNPJ</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3 ec-campo-switch">
                                        <label for="inputCadastroAtivo">Situação</label>
                                        <b-form-checkbox id="inputCadastroAtivo" v-model="cliente.ativo" name="inputCadastroAtivo" :value="'Ativo'" :unchecked-value="'Inativo'" :disabled="visualizar" :switch="true">
                                            {{ cliente.ativo=='Ativo' ? 'Ativa' : 'Inativa' }}
                                        </b-form-checkbox>
                                    </div>
                                    <div class="form-group col-12">
                                        <label for="inputCodigoEmpresa" class="ec-obrigatorio">Empresa</label>
                                        <select :disabled="visualizar" id="inputCodigoEmpresa" name="inputCodigoEmpresa" class="custom-select" :class="{ 'is-invalid': errors.company_id }" v-model="codigoempresa">
                                            <option value="0">Selecione uma empresa</option>
                                            <option v-for="empresa in empresas" :value="empresa.id" :key="empresa.id">{{ empresa.nomecompleto }} - {{ empresa.nomereduzido }} - {{empresa.cnpj}}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.company_id">{{ errors.company_id[0] }}</div>
                                    </div>
                                    <div class="form-group col-lg-6">
                                        <label for="inputRazaoSocial" class="ec-obrigatorio">Nome completo</label>
                                        <input :readonly="visualizar" type="text" class="form-control" :class="{ 'is-invalid': errors.nomecompleto }" id="inputRazaoSocial" name="inputRazaoSocial" placeholder="Nome completo da unidade" v-model="cliente.nomecompleto">
                                        <div class="invalid-feedback" v-if="errors.nomecompleto">{{ errors.nomecompleto[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputNomeFantasia" class="ec-obrigatorio">Nome reduzido</label>
                                        <input :readonly="visualizar" type="text" maxlength="50" class="form-control" :class="{ 'is-invalid': errors.nomereduzido }" id="inputNomeFantasia" name="inputNomeFantasia" placeholder="Até 50 caracteres" v-model="cliente.nomereduzido">
                                        <div class="invalid-feedback" v-if="errors.nomereduzido">{{ errors.nomereduzido[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputCNPJ" class="ec-obrigatorio">CNPJ</label>
                                        <the-mask :readonly="visualizar" :masked="true" :mask="['##.###.###/####-##']" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.cnpj }" id="inputCNPJ" name="inputCNPJ" placeholder="00.000.000/0000-00" v-model="doc"/>
                                        <div class="invalid-feedback" v-if="errors.cnpj">{{ errors.cnpj[0] }}</div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="diagram-3"></b-icon> Códigos de integração</legend>
                                <div class="form-row">
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputCodigoUnidadeErp" class="ec-obrigatorio">Código da unidade (ERP)</label>
                                        <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidade }" id="inputCodigoUnidadeErp" name="inputCodigoUnidadeErp" placeholder="Ex.: 1" v-model="cliente.codigounidade">
                                        <div class="invalid-feedback" v-if="errors.codigounidade">{{ errors.codigounidade[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputCodigoUnidadePk" class="ec-obrigatorio">Código PK da unidade (ERP)</label>
                                        <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidadepk }" id="inputCodigoUnidadePk" name="inputCodigoUnidadePk" placeholder="Ex.: 101" v-model="cliente.codigounidadepk">
                                        <div class="invalid-feedback" v-if="errors.codigounidadepk">{{ errors.codigounidadepk[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputCodigoUnidadeCrm" class="ec-obrigatorio">Código da unidade (CRM)</label>
                                        <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.codigounidadeexterno }" id="inputCodigoUnidadeCrm" name="inputCodigoUnidadeCrm" placeholder="Ex.: 44" v-model="cliente.codigounidadeexterno">
                                        <div class="invalid-feedback" v-if="errors.codigounidadeexterno">{{ errors.codigounidadeexterno[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputOrigem">Origem (CRM)</label>
                                        <input :readonly="visualizar" type="text" inputmode="numeric" class="form-control" :class="{ 'is-invalid': errors.origem }" id="inputOrigem" name="inputOrigem" placeholder="Ex.: 9" v-model="cliente.origem">
                                        <div class="invalid-feedback" v-if="errors.origem">{{ errors.origem[0] }}</div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="telephone"></b-icon> Contato</legend>
                                <div class="form-row">
                                    <div class="form-group col-lg-6">
                                        <label for="inputEmail" class="ec-obrigatorio">E-mail</label>
                                        <input :readonly="visualizar" type="email" autocomplete="email" class="form-control" :class="{ 'is-invalid': errors.email }" id="inputEmail" name="inputEmail" placeholder="contato@unidade.com.br" v-model="cliente.email">
                                        <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputFone">Telefone</label>
                                        <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" :class="{ 'is-invalid': errors.telefone }" id="inputFone" name="inputFone" placeholder="(00)0000-0000" v-model="cliente.telefone"/>
                                        <div class="invalid-feedback" v-if="errors.telefone">{{ errors.telefone[0] }}</div>
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-3">
                                        <label for="inputCelular">Celular</label>
                                        <the-mask :readonly="visualizar" :masked="true" :mask="['(##)####-####','(##)#####-####']" type="tel" class="form-control" id="inputCelular" name="inputCelular" placeholder="(00)00000-0000" v-model="cliente.celular"/>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="geo-alt"></b-icon> Endereço</legend>
                                <div class="form-row">
                                    <div class="form-group col-sm-4 col-lg-2">
                                        <label for="inputCep">CEP</label>
                                        <the-mask :readonly="visualizar" :masked="true" :mask="['#####-###']" inputmode="numeric" class="form-control" id="inputCep" name="inputCep" placeholder="00000-000" v-model="cliente.cep"/>
                                    </div>
                                    <div class="form-group col-sm-8 col-lg-6">
                                        <label for="inputEndereco">Logradouro</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputEndereco" name="inputEndereco" placeholder="Rua, avenida..." v-model="cliente.logradouro">
                                    </div>
                                    <div class="form-group col-4 col-lg-1">
                                        <label for="inputNumero">Nº</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputNumero" name="inputNumero" placeholder="Nº" v-model="cliente.numero">
                                    </div>
                                    <div class="form-group col-8 col-lg-3">
                                        <label for="inputComplemento">Complemento</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputComplemento" name="inputComplemento" placeholder="Sala, bloco..." v-model="cliente.complemento">
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-4">
                                        <label for="inputBairro">Bairro</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputBairro" name="inputBairro" placeholder="Bairro ou distrito" v-model="cliente.bairro">
                                    </div>
                                    <div class="form-group col-sm-6 col-lg-4">
                                        <label for="inputCidade">Cidade</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputCidade" name="inputCidade" placeholder="Cidade" v-model="cliente.cidade">
                                    </div>
                                    <div class="form-group col-6 col-lg-2">
                                        <label for="inputUF">UF</label>
                                        <select :disabled="visualizar" id="inputUF" name="inputUF" class="custom-select" v-model="cliente.estado">
                                            <option value="">Selecione</option>
                                            <option v-for="uf in ufs" :key="uf" :value="uf">{{ uf }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-6 col-lg-2">
                                        <label for="inputPais">País</label>
                                        <input :readonly="visualizar" type="text" class="form-control" id="inputPais" name="inputPais" placeholder="Brasil" v-model="cliente.pais">
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset class="ec-form-secao">
                                <legend><b-icon icon="grid"></b-icon> Módulos licenciados</legend>
                                <div class="form-row">
                                    <div v-for="modulo in modulos" :key="modulo.campo" class="form-group col-sm-6 col-lg-4">
                                        <b-form-checkbox :id="modulo.campo" v-model="cliente[modulo.campo]" :name="modulo.campo" :value="1" :unchecked-value="0" :disabled="visualizar" :switch="true">{{ modulo.titulo }}</b-form-checkbox>
                                        <small v-if="moduloSeraDesligado(modulo.campo)" class="form-text text-danger">
                                            <b-icon icon="exclamation-triangle"></b-icon> Ao salvar, o acesso dos usuários a este módulo será removido.
                                        </small>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </template>

                <div class="ec-form-acoes">
                    <span v-if="alterado" class="cfg-nao-salvo"><b-icon icon="circle-fill" font-scale=".6"></b-icon> Alterações não salvas</span>
                    <span v-else class="ec-form-legenda">Campos obrigatórios</span>
                    <b-dropdown variant="outline-primary" right :disabled="!!exportando" class="cfg-exportar">
                        <template #button-content>
                            <span v-if="exportando" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <b-icon v-else icon="cloud-upload"></b-icon> {{ exportando ? 'Exportando...' : 'Exportar para o CRM' }}
                        </template>
                        <b-dropdown-item-button @click="exportarUnidadeCrm()"><b-icon icon="building"></b-icon> Unidade (Rubeus)</b-dropdown-item-button>
                        <b-dropdown-item-button @click="exportarLocaisOfertaCrm()"><b-icon icon="geo"></b-icon> Local de oferta</b-dropdown-item-button>
                    </b-dropdown>
                    <a :href="'/Access/Unity/Unitie/'+cliente.id" class="btn btn-outline-primary" @click="confirmarSaida($event)">{{ alterado ? 'Descartar' : 'Voltar' }}</a>
                    <button type="submit" class="btn btn-primary" :disabled="salvando || (edit && !alterado)" :title="edit && !alterado ? 'Nenhuma alteração para salvar' : 'Salvar (Ctrl+S)'">
                        <span v-if="salvando" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <b-icon v-else icon="check2"></b-icon> {{ salvando ? 'Salvando...' : 'Salvar' }}
                    </button>
                </div>
            </form>
        </div>
        <loading id="SalvandoConfiguracoes" titulo="Salvando configurações da unidade, aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
    </div>
</template>

<script>

// macros aceitas por SchoolClass::getNomeOfertaMascaraUnidade(), com um valor de exemplo para a prévia
const MACROS = [
    { nome:'ANOINICIO', descricao:'Ano de início', exemplo:'2026' },
    { nome:'SEMESTREINICIO', descricao:'Semestre de início', exemplo:'1' },
    { nome:'CURSODOCUMENTO', descricao:'Nome do curso no documento', exemplo:'Ensino Fundamental' },
    { nome:'CURSO', descricao:'Nome do curso', exemplo:'Fundamental' },
    { nome:'PRODUTOOUCICLO', descricao:'Etapa', exemplo:'5º Ano' },
    { nome:'DESCRICAO', descricao:'Descrição da turma', exemplo:'92M' },
    { nome:'TURNO', descricao:'Turno', exemplo:'Manhã' },
    { nome:'CODIGOTURNO', descricao:'Código do turno', exemplo:'1' },
    { nome:'MODALIDADE', descricao:'Modalidade', exemplo:'Presencial' },
    { nome:'SALA', descricao:'Sala', exemplo:'Sala 12' },
    { nome:'CARGAHORARIAPRODUTO', descricao:'Carga horária', exemplo:'800' },
    { nome:'SITUACAOTURMA', descricao:'Situação da turma', exemplo:'Aberta' },
    { nome:'CODIGOSITUACAOTURMA', descricao:'Código da situação', exemplo:'1' },
    { nome:'DATAINICIO', descricao:'Data de início', exemplo:'01/02/2026' },
    { nome:'DATATERMINO', descricao:'Data de término', exemplo:'15/12/2026' },
    { nome:'TAMANHOTURMAMINIMO', descricao:'Vagas mínimas', exemplo:'10' },
    { nome:'TAMANHOTURMAMAXIMO', descricao:'Vagas máximas', exemplo:'35' },
    { nome:'CODIGOTURMA', descricao:'Código da turma', exemplo:'1234' },
    { nome:'CODIGOEMPRESA', descricao:'Código da empresa', exemplo:'1' },
    { nome:'CODIGOUNIDADE', descricao:'Código da unidade', exemplo:'1' },
    { nome:'CODIGOUNIDADEPK', descricao:'Código PK da unidade', exemplo:'101' },
]

// campos salvos pelo formulário: base para detectar alterações não salvas
const CAMPOS_SALVOS = ['company_id','codigounidade','codigounidadepk','codigounidadeexterno','nomecompleto','nomereduzido','cnpj','email','telefone','celular',
    'logradouro','numero','complemento','bairro','cidade','estado','pais','cep','oferta_processo_seletivo','oferta_Inscricao_web','inscricao_web_aluno',
    'importar_parcela','download_contrato','ativo','origem','mascaraofertainscricao','mascaraofertapse','codigotipocontatotelefone','codigotipocontatoemail']

export default{
    props:{
        documentosConfigurados:{
            type:Array,
            required:true
        },
        listagemCamposPersonalizados:{
            type:Array,
            required:true
        },
        listagemDocumentos:{
            type:Array,
            required:true
        },
        tipoContatoEmail:{
            type:Array,
            required:true
        },
        tipoContatoTelefone:{
            type:Array,
            required:true
        },
        urlSistema:{
            type:String,
            required:true
        },
        visualizar:{
            type:Boolean,
            required:true
        },
        nomeFormulario:{
            type:String,
            required:true
        },
        metodoFormulario:{
            type:String,
            required:true
        },
        linkAction:{
            type:String,
            required:true
        },
        pessoa:{
            type:Object,
            required:false
        },
        empresas:{
            type:Array,
            required:true
        },
        usuarioAutenticado:{
            type:Object,
            required:false
        },
        usuarios:[],
        edit:{
            type:Boolean,
            required:true
        }
    },
    data(){
        return{
            ufs:['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'],
            macros:MACROS,
            exemplos:[
                'ANOINICIO-CURSODOCUMENTO-PRODUTOOUCICLO-TURNO',
                'ANOINICIO-CURSODOCUMENTO-PRODUTOOUCICLO-DESCRICAO',
                'ANOINICIO-SEMESTREINICIO-CURSODOCUMENTO-PRODUTOOUCICLO-DESCRICAO',
                'CURSODOCUMENTO-PRODUTOOUCICLO-DESCRICAO',
            ],
            modulos:[
                { campo:'oferta_processo_seletivo', titulo:'Oferta de processo seletivo' },
                { campo:'oferta_Inscricao_web', titulo:'Oferta de inscrição web' },
                { campo:'inscricao_web_aluno', titulo:'Inscrição do aluno' },
                { campo:'importar_parcela', titulo:'Importação de parcela' },
                { campo:'download_contrato', titulo:'Download de contrato' },
            ],
            mascaraAlvo:'mascaraofertainscricao',
            salvo:{},
            salvando:false,
            salvandoDocumento:false,
            sincronizando:false,
            mostrarTodosPendentes:false,
            exportando:null,
            tipoCadastro:null,
            doc:null,
            codigoempresa:0,
            docs_lista:[],
            campos_lista:[],
            docs_configurados_unidade:[],
            docs_custom_fields:{
                unity_id:null,
                document_id:0,
                custom_field_id:0,
                obrigatorio:0,
                id:null
            },
            cliente:{
                id:null,
                nomecompleto:null,
                nomereduzido:null,
                cnpj:null,
                logradouro:null,
                numero:null,
                complemento:null,
                cep:null,
                pais:null,
                estado:null,
                cidade:null,
                bairro:null,
                site:null,
                email:null,
                telefone:null,
                celular:null,
                codigounidade:null,
                company_id:null,
                ativo:null,
                origem:null,
                /**
                 * cpf = 1
                 * cnpj = 2
                 */
                CadastroTipo:0,
            },
            errors:{},
        }
    },
    computed:{
        macrosPorNome(){
            return MACROS.reduce((mapa, macro) => { mapa[macro.nome] = macro; return mapa }, {})
        },
        mascaras(){
            return [
                { campo:'mascaraofertainscricao', erro:'mascarainscricao', id:'inputmascarainscricao', titulo:'Máscara da oferta de inscrição', modulo:'Inscrição web',
                  placeholder:'Ex.: ANOINICIO-CURSODOCUMENTO-PRODUTOOUCICLO-TURNO', obrigatoria:this.cliente.oferta_Inscricao_web==1 },
                { campo:'mascaraofertapse', erro:'mascarapse', id:'inputmascarapse', titulo:'Máscara da oferta PSE', modulo:'Processo seletivo',
                  placeholder:'Ex.: ANOINICIO-SEMESTREINICIO-CURSODOCUMENTO-DESCRICAO', obrigatoria:this.cliente.oferta_processo_seletivo==1 },
            ].map(m => Object.assign(m, { analise:this.analisarMascara(this.cliente[m.campo]) }))
        },
        mascarasPendentes(){
            return this.mascaras.some(m => m.obrigatoria && !this.cliente[m.campo])
        },
        editandoDocumento(){
            return !!this.docs_custom_fields.id
        },
        camposSemRelacao(){
            let relacionados = this.docs_configurados_unidade.map(d => d.custom_field_id)
            return this.campos_lista.filter(c => !relacionados.includes(c.id))
        },
        camposPendentesVisiveis(){
            return this.mostrarTodosPendentes ? this.camposSemRelacao : this.camposSemRelacao.slice(0, 8)
        },
        alterado(){
            return CAMPOS_SALVOS.some(campo => this.valorComparavel(this.cliente[campo]) !== this.valorComparavel(this.salvo[campo]))
        },
        // erros de validação, com o nome amigável de cada campo
        resumoErros(){
            let titulos = {
                mascarainscricao:'Máscara da oferta de inscrição',
                mascarapse:'Máscara da oferta PSE',
                codigotipocontatotelefone:'Tipo de contato para telefone',
                codigotipocontatoemail:'Tipo de contato para e-mail',
                custom_field_id:'Campo personalizado (CRM)',
                document_id:'Documento do aluno (ERP)',
                company_id:'Empresa',
                nomecompleto:'Nome completo',
                nomereduzido:'Nome reduzido',
                cnpj:'CNPJ',
                codigounidade:'Código da unidade (ERP)',
                codigounidadepk:'Código PK da unidade (ERP)',
                codigounidadeexterno:'Código da unidade (CRM)',
                origem:'Origem (CRM)',
                email:'E-mail',
                telefone:'Telefone',
            }
            let erros = this.errors || {}
            return Object.keys(titulos)
                .filter(campo => erros[campo])
                .map(campo => ({ campo, titulo:titulos[campo], mensagens:erros[campo] }))
        },
        possuiErroConfiguracao(){
            let erros = this.errors || {}
            return ['mascarainscricao','mascarapse','codigotipocontatotelefone','codigotipocontatoemail','custom_field_id','document_id'].some(campo => erros[campo])
        },
        possuiErroDadosUnidade(){
            let erros = this.errors || {}
            return ['company_id','nomecompleto','nomereduzido','cnpj','codigounidade','codigounidadepk','codigounidadeexterno','origem','email','telefone'].some(campo => erros[campo])
        },
    },
    methods:{
        avisar(mensagem,variante,titulo){
            this.$bvToast.toast(mensagem, {
                title: titulo,
                variant: variante,
                solid: true,
                toaster: 'b-toaster-top-right',
                autoHideDelay: variante=='danger' ? 8000 : 4000,
            })
        },
        valorComparavel(valor){
            return (valor===null || valor===undefined) ? '' : String(valor)
        },
        guardarEstadoSalvo(){
            this.salvo = CAMPOS_SALVOS.reduce((estado, campo) => { estado[campo] = this.cliente[campo]; return estado }, {})
        },
        // desligar um módulo remove a permissão dos usuários da unidade (Api\UnityController@update)
        moduloSeraDesligado(campo){
            return this.edit && this.salvo[campo]==1 && this.cliente[campo]!=1
        },

        // ----- máscaras -----
        tokensMascara(valor){
            return valor ? String(valor).split('-').map(t => t.trim().toUpperCase()) : []
        },
        analisarMascara(valor){
            let tokens = this.tokensMascara(valor)
            return {
                tokens,
                invalidas: tokens.filter(t => t && !this.macrosPorNome[t]),
                previa: this.montarPrevia(valor),
            }
        },
        // mesma regra do backend (SchoolClass::getNomeOfertaMascaraUnidade) com valores de exemplo
        montarPrevia(valor){
            let tokens = this.tokensMascara(valor)
            let anoESemestre = tokens.includes('ANOINICIO') && tokens.includes('SEMESTREINICIO')
            let partes = []
            tokens.forEach(token => {
                let macro = this.macrosPorNome[token]
                if(!macro) return
                if(anoESemestre && token=='SEMESTREINICIO') return
                if(anoESemestre && token=='ANOINICIO'){
                    partes.push(this.cliente.escrevesemestreextenso==1 ? '2026 - 1º Semestre' : '2026/1')
                    return
                }
                partes.push(macro.exemplo)
            })
            return partes.join(' - ')
        },
        normalizarMascara(campo){
            let valor = this.cliente[campo]
            if(!valor) return
            this.cliente[campo] = String(valor).toUpperCase().replace(/\s+/g,'').replace(/-{2,}/g,'-').replace(/^-|-$/g,'')
        },
        macroUsada(nome){
            return this.tokensMascara(this.cliente[this.mascaraAlvo]).includes(nome)
        },
        adicionarMacro(nome){
            let campo = this.mascaraAlvo
            let tokens = this.tokensMascara(this.cliente[campo]).filter(t => t)
            tokens.push(nome)
            this.cliente[campo] = tokens.join('-')
        },
        removerMacro(campo,indice){
            let tokens = this.tokensMascara(this.cliente[campo])
            tokens.splice(indice,1)
            this.cliente[campo] = tokens.filter(t => t).join('-')
        },
        usarExemplo(exemplo){
            let campo = this.mascaraAlvo
            if(this.cliente[campo] && this.cliente[campo]!=exemplo && !window.confirm('Substituir a máscara atual pelo exemplo?')) return
            this.cliente[campo] = exemplo
        },

        // ----- navegação -----
        mostrarAba(id){
            $('#configTab a[href="#'+id+'"]').tab('show')
        },
        abaDoCampo(campo){
            if(['mascarainscricao','mascarapse'].includes(campo)) return 'mascaras'
            if(['codigotipocontatotelefone','codigotipocontatoemail'].includes(campo)) return 'tipocontato'
            if(['custom_field_id','document_id'].includes(campo)) return 'tipodocumento'
            return 'dadosunidade'
        },
        irParaCampo(campo){
            let ids = { mascarainscricao:'inputmascarainscricao', mascarapse:'inputmascarapse', codigotipocontatotelefone:'inputCodigoTipoContatoTelefone',
                codigotipocontatoemail:'inputCodigoTipoContatoEmail', custom_field_id:'camposPersonalizado', document_id:'docsAluno', company_id:'inputCodigoEmpresa',
                nomecompleto:'inputRazaoSocial', nomereduzido:'inputNomeFantasia', cnpj:'inputCNPJ', codigounidade:'inputCodigoUnidadeErp', codigounidadepk:'inputCodigoUnidadePk',
                codigounidadeexterno:'inputCodigoUnidadeCrm', origem:'inputOrigem', email:'inputEmail', telefone:'inputFone' }
            let aba = this.abaDoCampo(campo)
            let focar = () => {
                let el = document.getElementById(ids[campo])
                if(el){ el.focus(); el.scrollIntoView({ block:'center', behavior:'smooth' }) }
            }
            if($('#'+aba).hasClass('active')){
                focar()
            }else{
                $('#configTab a[href="#'+aba+'"]').one('shown.bs.tab', focar)
                this.mostrarAba(aba)
            }
        },
        mostrarPrimeiroErro(){
            if(this.resumoErros.length){
                this.$nextTick(() => this.mostrarAba(this.abaDoCampo(this.resumoErros[0].campo)))
            }
        },
        confirmarSaida(evento){
            if(this.alterado && !window.confirm('Descartar as alterações não salvas?')){
                evento.preventDefault()
            }else{
                this.salvo = Object.assign({}, this.cliente) // não pergunta de novo no beforeunload
            }
        },
        avisoAoSair(evento){
            if(this.alterado){
                evento.preventDefault()
                evento.returnValue = ''
            }
        },
        atalhoSalvar(evento){
            if((evento.ctrlKey || evento.metaKey) && evento.key && evento.key.toLowerCase()=='s'){
                evento.preventDefault()
                if(!this.salvando && (!this.edit || this.alterado)) this.insereOuAtualiza()
            }
        },

        // ----- documentos obrigatórios -----
        campoJaRelacionado(id){
            return this.docs_configurados_unidade.some(d => d.custom_field_id==id && d.id!=this.docs_custom_fields.id)
        },
        novoDocumentCustomField(){
            return { unity_id:this.cliente.id, document_id:0, custom_field_id:0, obrigatorio:0, id:null }
        },
        tratarRespostaDocumento(response){
            if(response.data.success==false){
                this.avisar(response.data.message || 'Não foi possível concluir a operação.', 'danger', 'Documentos obrigatórios')
            }else{
                this.avisar(response.data.message || 'Configuração atualizada.', 'success', 'Documentos obrigatórios')
                this.docs_configurados_unidade = response.data.list_document_custom_field
                this.docs_custom_fields = this.novoDocumentCustomField()
            }
            this.errors = {}
        },
        tratarErroDocumento(errors){
            console.log(errors.response)
            if(errors.response && errors.response.data && errors.response.data.errors){
                this.errors = errors.response.data.errors
            }else{
                this.avisar('Erro ao salvar. Tente novamente.', 'danger', 'Documentos obrigatórios')
            }
        },
        montarFormDataDocumento(){
            let formData = new FormData();
            formData.append('custom_field_id', (this.docs_custom_fields.custom_field_id>0 ? this.docs_custom_fields.custom_field_id:null))
            formData.append('unity_id', (this.docs_custom_fields.unity_id>0 ? this.docs_custom_fields.unity_id:null))
            formData.append('document_id', (this.docs_custom_fields.document_id>0 ? this.docs_custom_fields.document_id:null))
            formData.append('obrigatorio', (this.docs_custom_fields.obrigatorio == 1 ? 1:0))
            return formData
        },
        inserirAlterarDocumentCustomField(){
            let url = '/api/v1/Access/Unity/Unitie/'+this.cliente.id+'/config/documentscustomfields'
            let formData = this.montarFormDataDocumento()
            if(this.editandoDocumento){
                url += '/'+this.docs_custom_fields.id
                formData.append('_method','patch')
                formData.append('id', this.docs_custom_fields.id)
            }
            this.salvandoDocumento = true
            axios.post(url,formData)
                .then(response => this.tratarRespostaDocumento(response))
                .catch(errors => this.tratarErroDocumento(errors))
                .finally(() => { this.salvandoDocumento = false })
        },
        excluirDocumentCustomField(doc){
            if(!window.confirm('Remover a relação "'+doc.custom_field.nome+'" → "'+doc.document.descricao+'"?')) return
            this.salvandoDocumento = true
            axios.delete('/api/v1/Access/Unity/Unitie/'+this.cliente.id+'/config/documentscustomfields/'+doc.id)
                .then(response => this.tratarRespostaDocumento(response))
                .catch(errors => {
                    console.log(errors)
                    this.avisar('Erro ao remover a relação. Tente novamente.', 'danger', 'Documentos obrigatórios')
                })
                .finally(() => { this.salvandoDocumento = false })
        },
        alterarConfigDoc(doc){
            // cópia: editar o formulário não altera a linha da tabela antes de salvar
            this.docs_custom_fields = Object.assign({}, doc, { unity_id:this.cliente.id })
            this.errors = {}
            this.$nextTick(() => {
                let el = document.getElementById('camposPersonalizado')
                if(el){ el.focus(); el.scrollIntoView({ block:'center', behavior:'smooth' }) }
            })
        },
        // atalho dos campos pendentes: já escolhe o campo do CRM e leva ao documento do ERP
        relacionarCampo(campo){
            this.docs_custom_fields = Object.assign(this.novoDocumentCustomField(), { custom_field_id:campo.id })
            this.errors = {}
            this.$nextTick(() => {
                let el = document.getElementById('docsAluno')
                if(el){ el.focus(); el.scrollIntoView({ block:'center', behavior:'smooth' }) }
            })
        },
        cancelarDocumentCustomField(){
            this.docs_custom_fields = this.novoDocumentCustomField()
            this.errors = {}
        },
        sincronizarTodos(){
            this.sincronizando = true
            Promise.all([
                axios.get('/api/v1/Erp/ListaTiposDocs/' + this.cliente.id).then(response => { this.docs_lista = response.data.lista_lista_docs || [] }),
                axios.get('/api/v1/Crm/ListaCamposPersonalizados/' + this.cliente.id).then(response => { this.campos_lista = response.data.lista_campos_personalizados || [] }),
            ])
                .then(() => this.avisar(this.docs_lista.length+' documento(s) do ERP e '+this.campos_lista.length+' campo(s) do CRM.', 'success', 'Listas sincronizadas'))
                .catch(errors => {
                    console.log(errors)
                    this.avisar('Não foi possível sincronizar as listas. Verifique a integração com o ERP e o CRM.', 'danger', 'Erro ao sincronizar')
                })
                .finally(() => { this.sincronizando = false })
        },

        // ----- unidade -----
        insereOuAtualiza(){
            this.mascaras.forEach(m => this.normalizarMascara(m.campo))
            if(!this.edit){
                this.inserirUnity();
            }else{
                this.atualizaUnity();
            }
        },
        montarFormDataUnidade(){
            let c = this.cliente
            let formData = new FormData();
            formData.append('tipocadastro', this.tipoCadastro)
            formData.append('company_id', (c.company_id?c.company_id:''))
            formData.append('codigounidade', (c.codigounidade?c.codigounidade:''))
            formData.append('codigounidadepk', (c.codigounidadepk?c.codigounidadepk:''))
            formData.append('codigounidadeexterno', (c.codigounidadeexterno?c.codigounidadeexterno:''))
            formData.append('nomecompleto', (c.nomecompleto?c.nomecompleto:''))
            formData.append('cnpj', (c.cnpj?c.cnpj:''))
            formData.append('email', (c.email?c.email:''))
            formData.append('telefone', (c.telefone?c.telefone:''))
            formData.append('celular', (c.celular?c.celular:''))
            formData.append('logradouro', (c.logradouro?c.logradouro:''))
            formData.append('numero', (c.numero?c.numero:''))
            formData.append('complemento', (c.complemento?c.complemento:''))
            formData.append('bairro', (c.bairro?c.bairro:''))
            formData.append('cidade', (c.cidade?c.cidade:''))
            formData.append('estado', (c.estado && c.estado != '0' ?c.estado:''))
            formData.append('pais', (c.pais && c.pais != '0' ?c.pais:''))
            formData.append('cep', (c.cep?c.cep:''))
            formData.append('urlapirubeus', (c.urlapirubeus?c.urlapirubeus:''))
            formData.append('tokenapirubeus', (c.tokenapirubeus?c.tokenapirubeus:''))
            formData.append('urlapigvdasa', (c.urlapigvdasa?c.urlapigvdasa:''))
            formData.append('tokenapigvdasa', (c.tokenapigvdasa?c.tokenapigvdasa:''))
            formData.append('oferta_processo_seletivo', (c.oferta_processo_seletivo?c.oferta_processo_seletivo:0))
            formData.append('oferta_Inscricao_web', (c.oferta_Inscricao_web?c.oferta_Inscricao_web:0))
            formData.append('inscricao_web_aluno', (c.inscricao_web_aluno?c.inscricao_web_aluno:0))
            formData.append('importar_parcela', (c.importar_parcela?c.importar_parcela:0))
            formData.append('download_contrato', (c.download_contrato?c.download_contrato:0))
            formData.append('ativo',(c.ativo=='Ativo'?'1':'0'))
            formData.append('origem', (c.origem?c.origem:''))
            formData.append('mascarainscricao', (c.mascaraofertainscricao?c.mascaraofertainscricao:''))
            formData.append('mascarapse', (c.mascaraofertapse?c.mascaraofertapse:''))
            formData.append('codigotipocontatotelefone', (c.codigotipocontatotelefone?c.codigotipocontatotelefone:null))
            formData.append('codigotipocontatoemail', (c.codigotipocontatoemail?c.codigotipocontatoemail:null))
            formData.append('nomereduzido', (this.tipoCadastro==2 && c.nomereduzido ? c.nomereduzido : ''))
            return formData
        },
        enviarUnidade(url,formData){
            this.salvando = true
            $('#SalvandoConfiguracoes').modal('show');
            axios.post(url,formData)
                .then(response => {
                    let unidade = response.data.usuarioNovo
                    if(!unidade){
                        this.avisar(response.data.mensagem || 'Não foi possível salvar.', 'danger', 'Erro ao salvar')
                        return
                    }
                    this.cliente = Object.assign({}, this.cliente, unidade, { CadastroTipo:2 })
                    this.codigoempresa = this.cliente.company_id
                    this.doc = this.cliente.cnpj
                    this.tipoCadastro = 2
                    this.errors = {}
                    this.guardarEstadoSalvo()
                    this.avisar('As configurações de '+(this.cliente.nomecompleto || 'unidade')+' foram salvas.', 'success', 'Configurações salvas')
                })
                .catch(errors => {
                    console.log(errors.response)
                    if(errors.response && errors.response.data && errors.response.data.errors){
                        this.errors = errors.response.data.errors
                        this.mostrarPrimeiroErro()
                    }else{
                        this.avisar('Erro inesperado ao salvar. Tente novamente.', 'danger', 'Erro ao salvar')
                    }
                })
                .finally(() => {
                    this.salvando = false
                    $('#SalvandoConfiguracoes').modal('hide');
                })
        },
        inserirUnity(){
            this.enviarUnidade('/api/v1/'+this.urlSistema, this.montarFormDataUnidade())
        },
        atualizaUnity(){
            let formData = this.montarFormDataUnidade()
            formData.append('_method','patch');
            this.enviarUnidade('/api/v1/'+this.urlSistema+'/'+this.cliente.id, formData)
        },
        podeExportar(){
            return !this.alterado || window.confirm('Há alterações não salvas. A exportação usará os dados já salvos. Continuar?')
        },
        exportarLocaisOfertaCrm(){
            if(!this.podeExportar()) return
            this.exportando = 'local'
            axios.post('/api/v1/Companies/Unity/CadastroLocaisOferta/'+this.cliente.id)
                .then(response => {
                    let local = response.data || {}
                    this.avisar('Unidade '+(local.codigounidade || '')+' exportada como local de oferta (id '+(local.codigolocaloferta || '—')+').', 'success', 'Local de oferta exportado')
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.avisar('Não foi possível exportar o local de oferta para o CRM.', 'danger', 'Erro na exportação')
                })
                .finally(() => { this.exportando = null })
        },
        exportarUnidadeCrm(){
            if(!this.podeExportar()) return
            this.exportando = 'unidade'
            axios.post('/api/v1/Crm/cadastroUnidade/'+this.cliente.id)
                .then(response => {
                    let dados = response.data.dadosUnidade || {}
                    let id = response.data.resposta_crm ? response.data.resposta_crm.id : '—'
                    this.avisar((dados.descricao || 'Unidade')+' (código '+(dados.codigo || '—')+') exportada para o CRM. Id: '+id+'.', 'success', 'Unidade exportada')
                })
                .catch(errors => {
                    console.log(errors.response)
                    this.avisar('Não foi possível exportar a unidade para o CRM.', 'danger', 'Erro na exportação')
                })
                .finally(() => { this.exportando = null })
        }
    },
    mounted(){
        window.addEventListener('beforeunload', this.avisoAoSair)
        window.addEventListener('keydown', this.atalhoSalvar)

        // mantém a aba aberta no endereço (recarregar/compartilhar o link volta para ela)
        let aba = window.location.hash.replace('#','')
        if(['mascaras','tipocontato','tipodocumento','dadosunidade'].includes(aba)) this.mostrarAba(aba)
        $('#configTab a[data-toggle="tab"]').on('shown.bs.tab', e => {
            history.replaceState(null, '', e.target.getAttribute('href'))
        })
    },
    beforeDestroy(){
        window.removeEventListener('beforeunload', this.avisoAoSair)
        window.removeEventListener('keydown', this.atalhoSalvar)
        $('#configTab a[data-toggle="tab"]').off('shown.bs.tab')
    },
    created(){
        if(this.pessoa){
            this.cliente = Object.assign({}, this.pessoa);
            this.codigoempresa = this.pessoa.company_id;
            this.doc=this.pessoa.cnpj;
            this.docs_custom_fields.unity_id = this.cliente.id
            this.docs_lista = this.listagemDocumentos;
            this.docs_configurados_unidade = this.documentosConfigurados;
            this.campos_lista = this.listagemCamposPersonalizados
            let cnpj = this.pessoa.cnpj || ''
            if(cnpj.length==14){
                this.cliente.CadastroTipo=1
                this.tipoCadastro=1
            }else{
                this.cliente.CadastroTipo=2
                this.tipoCadastro=2
            }
            this.guardarEstadoSalvo()
        }else{
            this.cliente.CadastroTipo=0;
            this.tipoCadastro=0;
            this.cliente.estado="0";
            this.codigoempresa=0;
        }
    },
    watch: {
        codigoempresa(newempresa,oldempresa){
            if(newempresa!=oldempresa){
                this.cliente.company_id = newempresa
            }
        },
        tipoCadastro(newTipoCadastro, oldTipoCadastro) {
            if (newTipoCadastro!=oldTipoCadastro) {
                this.cliente.CadastroTipo=newTipoCadastro;
                this.errors={};
            }
        },
        doc(newdoc, olddoc) {
            if (newdoc!=olddoc) {
                this.cliente.cnpj=newdoc;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

form {
    text-align: left !important;
}

// abas roláveis no celular
.cfg-abas {
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    .nav-link { white-space: nowrap; }
}

// ponto na aba: vermelho = erro, amarelo = pendência
.cfg-alerta {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-left: .3rem;
    border-radius: 50%;
    background: #d64545;
    vertical-align: middle;

    &--aviso { background: #e0a526; }
}

.cfg-contagem {
    margin-left: .25rem;
    font-size: .7rem;
    color: $ec-petroleo;
    background: rgba($ec-petroleo, .1);
}

// ----- máscaras -----
.cfg-mascara__input {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: .85rem;
    letter-spacing: .02em;
    text-transform: uppercase;

    &::placeholder { text-transform: none; }
    &--alvo:not(:focus):not(.is-invalid) { border-color: rgba($ec-turquesa, .55); }
}

.cfg-tokens {
    display: flex;
    flex-wrap: wrap;
    gap: .3rem;
    margin-top: .5rem;
}

.cfg-token {
    display: inline-flex;
    align-items: center;
    gap: .2rem;
    padding: .1rem .2rem .1rem .55rem;
    border-radius: 999px;
    font-size: .72rem;
    font-weight: 600;
    color: $ec-turquesa;
    background: rgba($ec-turquesa, .1);

    &--invalida {
        color: #b02a2a;
        background: rgba(#d64545, .12);
        text-decoration: line-through;
    }
}

.cfg-token__remover {
    border: 0;
    background: transparent;
    color: inherit;
    width: 1.1rem;
    height: 1.1rem;
    line-height: 1;
    border-radius: 50%;
    padding: 0;
    opacity: .65;
    cursor: pointer;

    &:hover { opacity: 1; background: rgba(0, 0, 0, .08); }
}

.cfg-previa {
    margin-top: .5rem;
    padding: .5rem .75rem;
    border-radius: .5rem;
    background: $ec-fundo;
    border: 1px dashed $ec-borda;
}

.cfg-previa__rotulo {
    display: block;
    font-size: .7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .05em;
    color: $ec-texto-suave;
}

.cfg-previa__texto {
    font-size: .9rem;
    font-weight: 600;
    color: $ec-texto;
    overflow-wrap: anywhere;
}

.cfg-macros {
    margin: .25rem 0 1rem;
    padding: .75rem;
    border-radius: .5rem;
    border: 1px solid $ec-borda;
}

.cfg-macros__cabecalho {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
    margin-bottom: .6rem;
    font-size: .8rem;
}

.cfg-macros__lista {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: .35rem;
}

.cfg-macro {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 .3rem;
    padding: .35rem .55rem;
    border: 1px solid $ec-borda;
    border-radius: .4rem;
    background: $ec-superficie;
    font-size: .72rem;
    font-weight: 700;
    color: $ec-petroleo;
    text-align: left;
    cursor: pointer;
    transition: border-color .15s ease, background-color .15s ease;

    small {
        width: 100%;
        padding-left: 1.15rem;
        font-weight: 400;
        color: $ec-texto-suave;
    }

    &:hover { border-color: $ec-turquesa; background: rgba($ec-turquesa, .05); }
    &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba($ec-turquesa, .3); }

    &--usada {
        background: rgba($ec-turquesa, .08);
        border-color: rgba($ec-turquesa, .4);
    }
}

.cfg-ajuda {
    margin-bottom: 1rem;
    font-size: .8rem;

    > summary {
        cursor: pointer;
        font-weight: 600;
        color: $ec-turquesa;
        margin-bottom: .5rem;
    }
}

.cfg-exemplos {
    display: flex;
    flex-direction: column;
    gap: .35rem;
}

.cfg-exemplo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .75rem;
    padding: .4rem .6rem;
    border-radius: .4rem;
    background: $ec-fundo;
}

.cfg-exemplo__textos {
    display: flex;
    flex-direction: column;
    min-width: 0;

    code { overflow-wrap: anywhere; }
}

// ----- documentos -----
.cfg-docs-cabecalho {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
    margin-bottom: 1rem;
}

// selo de origem: CRM (de) e ERP (para), mesmas cores no formulário e na tabela
$cfg-cor-crm: #6f42c1;

.cfg-origem {
    display: inline-block;
    margin-right: .3rem;
    padding: .05rem .45rem;
    border-radius: 999px;
    font-size: .65rem;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    vertical-align: middle;
    white-space: nowrap;

    &--crm { color: $cfg-cor-crm; background: rgba($cfg-cor-crm, .1); }
    &--erp { color: $ec-turquesa; background: rgba($ec-turquesa, .12); }
}

.cfg-depara-form {
    margin-bottom: 1rem;
    padding: .85rem;
    border: 1px solid $ec-borda;
    border-radius: .5rem;
    background: $ec-fundo;
    transition: background-color .2s ease, border-color .2s ease;

    &--editando {
        background: rgba($ec-turquesa, .06);
        border-color: rgba($ec-turquesa, .45);
        box-shadow: inset 3px 0 0 $ec-turquesa;
    }
}

.cfg-depara-form__titulo {
    font-size: .75rem;
    font-weight: 700;
    color: $ec-turquesa;
    margin-bottom: .5rem;
}

// [CRM] → [ERP] [botões]
.cfg-depara-grade {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto;
    align-items: end;
    gap: .5rem .75rem;

    label { display: block; margin-bottom: .3rem; }
}

.cfg-depara-grade__seta {
    display: flex;
    align-items: center;
    height: calc(1.55em + .9rem + 2px); // altura do select
    font-size: 1.15rem;
    color: $ec-texto-suave;
}

.cfg-depara-grade__acoes {
    display: flex;
    gap: .5rem;

    .btn { white-space: nowrap; }
}

.cfg-pendentes {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: .35rem;
    margin-bottom: 1rem;
    font-size: .78rem;
}

.cfg-pendentes__rotulo {
    font-weight: 600;
    color: #b7791f;
    margin-right: .15rem;
}

.cfg-pendente {
    display: inline-flex;
    align-items: center;
    gap: .15rem;
    padding: .1rem .55rem;
    border: 1px dashed rgba($cfg-cor-crm, .45);
    border-radius: 999px;
    background: transparent;
    font-size: .74rem;
    color: $cfg-cor-crm;
    cursor: pointer;

    &:hover:not(:disabled) { border-style: solid; background: rgba($cfg-cor-crm, .06); }
    &:disabled { opacity: .5; cursor: default; }
}

.cfg-depara {
    .cfg-depara__seta {
        width: 2.5rem;
        padding-left: 0;
        padding-right: 0;
        color: $ec-texto-suave;
    }
}

// celular (linha vira cartão): a seta entre as colunas não faz sentido
@media (max-width: 767.98px) {
    .cfg-depara tbody td.cfg-depara__seta { display: none; }
}

.cfg-depara__nome {
    font-weight: 600;
    color: $ec-texto;
}

.cfg-depara__codigo {
    display: inline-block;
    margin-left: .35rem;
    padding: 0 .35rem;
    border-radius: .25rem;
    font-size: .72rem;
    color: $ec-texto-suave;
    background: $ec-fundo;
}

.cfg-depara__linha--editando > td { background: rgba($ec-turquesa, .08); }

.cfg-depara__vazio {
    display: inline-flex;
    align-items: center;
    gap: .5rem;
    margin-bottom: .5rem;
    font-size: 1rem;
    opacity: .8;
}

@media (max-width: 767.98px) {
    // empilha: CRM, seta para baixo, ERP, botões
    .cfg-depara-grade { grid-template-columns: minmax(0, 1fr); }
    .cfg-depara-grade__seta { height: auto; justify-content: center; transform: rotate(90deg); }
    .cfg-depara-grade__acoes .btn { flex: 1 1 auto; }
}

.table thead th {
    vertical-align: bottom;
    border: 0px solid #1c4d5a;
}

// ----- barra de ações -----
.cfg-nao-salvo {
    margin-right: auto;
    font-size: .78rem;
    font-weight: 600;
    color: #b7791f;
}

@media (max-width: 575.98px) {
    .cfg-nao-salvo { width: 100%; }
    .cfg-exportar { flex: 1 1 auto; }
}

</style>
